// Public product URLs used by the Services section and mentoring showcases.
export const PROJECT_LINKS = Object.freeze({
  kursa: 'https://getkursa.space/?demo=yes',
  bootcamps: 'https://bootcamps.csl-brands.com',
  shopikat: 'https://shopikat.com',
  primecorn: 'https://primecorn.net',
  tchopnjoh: 'https://tchopnjoh.com',
});
